module.exports = __webpack_public_path__ + "static/media/bike-city.1205a5f5.svg";